import React from 'react'
import { formatTemplateName } from './waTemplateUtils'

const WA = '#25D366'
const WA_DARK = '#128C7E'

// Created By Cursor — Meta Graph vs EduOK Database verify report
export default function WhatsAppTemplateVerifyReportDialog({
  report,
  matched,
  synced,
  message,
  onClose,
}) {
  const rows = Array.isArray(report?.rows) ? report.rows : []
  const allMatch = report?.all_match === true || matched === true
  const titleName = formatTemplateName(report?.template_label || '')

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 23, 42, 0.52)',
        backdropFilter: 'blur(4px)',
        zIndex: 1060,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 16,
          width: '100%',
          maxWidth: 820,
          maxHeight: '86vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 24px 48px rgba(15, 23, 42, 0.22)',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 12,
            padding: '16px 18px',
            borderBottom: '1px solid #e2e8f0',
            background: 'linear-gradient(180deg, #f8fafc 0%, #fff 100%)',
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div
              style={{
                fontSize: 12,
                fontWeight: 800,
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
                color: '#64748b',
                marginBottom: 4,
              }}
            >
              Verify From Meta
            </div>
            <div
              style={{
                fontSize: 18,
                fontWeight: 800,
                color: '#0f172a',
                lineHeight: 1.3,
              }}
            >
              {titleName || 'Template comparison'}
            </div>
            <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              <span
                style={{
                  fontSize: 12,
                  fontWeight: 800,
                  padding: '4px 10px',
                  borderRadius: 999,
                  background: allMatch ? '#dcfce7' : '#fef9c3',
                  color: allMatch ? '#166534' : '#854d0e',
                }}
              >
                {allMatch ? 'All fields match' : 'Differences found'}
              </span>
              {synced ? (
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 800,
                    padding: '4px 10px',
                    borderRadius: 999,
                    background: '#dbeafe',
                    color: '#1d4ed8',
                  }}
                >
                  Synced into EduOK Database
                </span>
              ) : null}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            style={{
              border: '1px solid #cbd5e1',
              background: '#fff',
              color: '#475569',
              width: 36,
              height: 36,
              borderRadius: 8,
              fontWeight: 800,
              fontSize: 18,
              lineHeight: 1,
              cursor: 'pointer',
              flexShrink: 0,
            }}
          >
            ×
          </button>
        </div>

        <div style={{ padding: '14px 18px', overflow: 'auto', flex: 1 }}>
          {message ? (
            <div
              style={{
                marginBottom: 12,
                padding: '10px 12px',
                borderRadius: 10,
                background: allMatch ? '#f0fdf4' : synced ? '#eff6ff' : '#fffbeb',
                border: `1px solid ${allMatch ? '#86efac' : synced ? '#93c5fd' : '#fde68a'}`,
                color: '#0f172a',
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              {message}
            </div>
          ) : null}

          <div
            style={{
              border: '1px solid #e2e8f0',
              borderRadius: 12,
              overflow: 'hidden',
            }}
          >
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: 13,
              }}
            >
              <thead>
                <tr style={{ background: '#f8fafc' }}>
                  {['Field', 'Meta Graph', 'EduOK Database', 'Match?'].map((h) => (
                    <th
                      key={h}
                      style={{
                        textAlign: 'left',
                        padding: '10px 12px',
                        fontWeight: 800,
                        fontSize: 11,
                        letterSpacing: '0.04em',
                        textTransform: 'uppercase',
                        color: '#64748b',
                        borderBottom: '1px solid #e2e8f0',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td
                      colSpan={4}
                      style={{
                        padding: 20,
                        textAlign: 'center',
                        color: '#94a3b8',
                        fontWeight: 600,
                      }}
                    >
                      No comparison rows
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => {
                    const ok = !!row.match
                    return (
                      <tr key={row.field} style={{ background: ok ? '#fff' : '#fffbeb' }}>
                        <td
                          style={{
                            padding: '10px 12px',
                            fontWeight: 800,
                            color: '#0f172a',
                            borderBottom: '1px solid #f1f5f9',
                            verticalAlign: 'top',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {row.field}
                        </td>
                        <td
                          style={{
                            padding: '10px 12px',
                            color: '#334155',
                            fontWeight: 600,
                            borderBottom: '1px solid #f1f5f9',
                            verticalAlign: 'top',
                            wordBreak: 'break-word',
                          }}
                        >
                          {row.meta || '—'}
                        </td>
                        <td
                          style={{
                            padding: '10px 12px',
                            color: '#334155',
                            fontWeight: 600,
                            borderBottom: '1px solid #f1f5f9',
                            verticalAlign: 'top',
                            wordBreak: 'break-word',
                          }}
                        >
                          {ok ? 'same' : row.eduok || '—'}
                        </td>
                        <td
                          style={{
                            padding: '10px 12px',
                            borderBottom: '1px solid #f1f5f9',
                            verticalAlign: 'top',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <span
                            style={{
                              fontWeight: 800,
                              fontSize: 12,
                              padding: '3px 8px',
                              borderRadius: 999,
                              background: ok ? '#dcfce7' : '#fee2e2',
                              color: ok ? '#166534' : '#991b1b',
                              textTransform: 'lowercase',
                            }}
                          >
                            {ok ? 'yes' : 'no'}
                          </span>
                        </td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div
          style={{
            padding: '12px 18px',
            borderTop: '1px solid #e2e8f0',
            display: 'flex',
            justifyContent: 'flex-end',
            background: '#fff',
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              border: 'none',
              background: `linear-gradient(135deg, ${WA_DARK}, ${WA})`,
              color: '#fff',
              fontWeight: 800,
              fontSize: 14,
              padding: '10px 18px',
              borderRadius: 8,
              cursor: 'pointer',
              boxShadow: '0 3px 10px rgba(37, 211, 102, 0.22)',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
